// src/components/PostHogProvider.tsx
"use client";

import { useEffect } from "react";
import { initPostHog } from "@/lib/analytics";

export function PostHogProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    initPostHog();
  }, []);

  return <>{children}</>;
}
